import React from 'react'

class EmailPasswordContainer extends React.PureComponent{
  render(){
    return <div>THIS IS NOT SUPPORTED YET!</div>
  }
}

export default EmailPasswordContainer



// WEBPACK FOOTER //
// ./src/Containers/BasicAuthContainer.js